import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxLoadIndicatorModule, DxTemplateModule, DxTooltipModule} from "devextreme-angular";
import {take} from "rxjs/operators";
import {FlexModule} from "@angular/flex-layout";
import {ResultAnalyzerService} from "../../services/result-analyzer.service";

@Component({
  selector: 'app-ai-result-indicator',
  standalone: true,
  imports: [CommonModule, DxTemplateModule, DxTooltipModule, DxLoadIndicatorModule, FlexModule],
  templateUrl: './ai-result-indicator.component.html',
  styleUrls: ['./ai-result-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiResultIndicatorComponent implements OnChanges {
  @Input() orderCode?: string;
  hasBeenAnalyzed: boolean = false;
  isLoading: boolean = true;

  constructor(public service: ResultAnalyzerService, private changesDetector: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderCode && changes.orderCode.currentValue) {
      this.service.checkIfOrderHasBeenAnalyzed(changes.orderCode.currentValue)
        .pipe(take(1))
        .subscribe(x => {
          this.isLoading = false;
          this.hasBeenAnalyzed = x;
          this.changesDetector.detectChanges();
        });
    }
  }
}
